import React from 'react';
import { useTranslation } from 'react-i18next';
import PlanDetailHeader from '../../components/PlanDetailHeader';
import NameStatusSection from './components/NameStatusSection';
import LawReferenceSection from './components/LawReferenceSection';
import FormFooterActions from './components/FormFooterActions';
import type { PlanInfoFormValues, SelectOption } from '../../types';
import styles from './PlanInfoPage.module.css';

interface PlanInfoPageProps {
    values: PlanInfoFormValues;
    plantypeOptions: SelectOption[];
    planstatusOptions: SelectOption[];
    lovreferanseOptions: SelectOption[];
    onChange: (field: keyof PlanInfoFormValues, value: string) => void;
    onCancel: () => void;
    onSave: () => void;
    saveDisabled?: boolean;
    isSaving?: boolean;
    /** Vises kun når brukeren har gjort endringer som ikke er lagret. */
    isDirty?: boolean;
}

// TODO(håvard): "Planbestemmelser" er et eget felt i NameStatusSection i
// Figma 1:591 (full bredde, under Type/Status). Bør inn i PlanInfoFormValues
// + NameStatusSection når datamodellen lander.
const PlanInfoPage: React.FC<PlanInfoPageProps> = ({
    values,
    plantypeOptions,
    planstatusOptions,
    lovreferanseOptions,
    onChange,
    onCancel,
    onSave,
    saveDisabled,
    isSaving,
    isDirty,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={styles.stickyActionsSlot} data-open={isDirty ? 'true' : 'false'}>
                <div className={styles.stickyActions}>
                    <FormFooterActions
                        onCancel={onCancel}
                        onSave={onSave}
                        saveDisabled={saveDisabled}
                        isSaving={isSaving}
                        placement="top"
                    />
                </div>
            </div>
            <article className={styles.page}>
                <PlanDetailHeader title={t('planInfo.title')} subtitle={t('planInfo.subtitle')} />
                <NameStatusSection
                    values={{
                        plannavn: values.plannavn,
                        plantype: values.plantype,
                        planstatus: values.planstatus,
                    }}
                    plantypeOptions={plantypeOptions}
                    planstatusOptions={planstatusOptions}
                    onChange={onChange}
                />
                <LawReferenceSection
                    values={{ lovreferanse: values.lovreferanse, beskrivelse: values.beskrivelse }}
                    lovreferanseOptions={lovreferanseOptions}
                    onChange={onChange}
                />
                {isDirty && (
                    <FormFooterActions
                        onCancel={onCancel}
                        onSave={onSave}
                        saveDisabled={saveDisabled}
                        isSaving={isSaving}
                    />
                )}
            </article>
        </>
    );
};

export default PlanInfoPage;
